import BasicDetails from "../../components/pages/insurance/property/form-tabs/BasicDetails";
import PropertyOptions from "../../components/pages/insurance/property/form-tabs/PropertyOptions";
import PropertyQuestions from "../../components/pages/insurance/property/form-tabs/PropertyQuestions";
import PropertyDeclarations from "../../components/pages/insurance/property/form-tabs/PropertyDeclarations";

export const tabs = [
	{
		id: "basic-details",
		title: "Proposer Details",
		content: BasicDetails,
	},
	{
		id: "property-questions",
		title: "Cover Levels",
		content: PropertyQuestions,
	},
	{
		id: "declaration",
		title: "Declarations",
		content: PropertyDeclarations,
	},

];

export const tabsCount = tabs.length;
